/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum DependencyModeTypes {
	all = 'all',
	allStandard = 'all-target',
	allSpecial = 'all-special',
	standard = 'standard',
	hidden = 'hidden',
}

// export enum DependencyWeight{
// 	primary = "primary",
// 	secondary = "secondary"
// }

export enum DependencyKeys {
	predecessors = 'predecessors',
}

export interface DependencyMode {
	type: DependencyModeTypes;
	isAllType: boolean;
	target?: string;
	depth?: number;
}

export interface DependencyDisplay {
	srcPlan: string;
	srcTicket: string;
	targetPlan: string;
	targetTicket: string;
}
